__turbopack_context__.v({
  "alertsBar": "investor-alerts-bar-module-scss-module__y4xnra__alertsBar",
  "alertsBarIn": "investor-alerts-bar-module-scss-module__y4xnra__alertsBarIn",
  "alertsBarT": "investor-alerts-bar-module-scss-module__y4xnra__alertsBarT",
});
